<template>
  <v-row justify="center">
    <v-dialog
      v-if="dialog"
      v-model="dialog"
      persistent
      max-width="1000px"
      transition="fade-transition"
    >
      <v-card>
        <v-toolbar
          color="primary"
          dark
          flat
          dense
        >
          <v-toolbar-title class="text-h5">
            Cadastro do Cliente
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div style="overflow-y: auto; padding: 16px; max-height: calc(90vh - 48px);">
          <v-form
            ref="form"
            v-model="isValid"
          >
            <v-card-text
              elevation="0"
              class="pt-2"
            >
              <v-container>
                <v-row align="center">
                  <v-col class="pt-0">
                    <v-switch
                      v-model="form.data.enabled"
                      :label="`${checkboxChecker(form.data.enabled)}`"
                      color="success"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      v-model="form.data._id"
                      :label="`ID`"
                      class="rounded-lg"
                      outlined
                      dense
                      readonly
                    />
                  </v-col>
                </v-row>

                <v-card
                  class="pa-4 rounded-xl"
                  elevation="3"
                >
                  <v-card-text
                    class="mb-2 ps-0 justify-start"
                  >
                    <h4 class="d-flex align-center">
                      <v-icon
                        class="me-1"
                        small
                        color="primary"
                        left
                      >
                        mdi-information-outline
                      </v-icon>
                      Dados Gerais
                    </h4>
                  </v-card-text>

                  <v-divider class="mb-4" />

                  <v-row dense>
                    <v-col
                      cols="12"
                      md="8"
                    >
                      <v-text-field
                        v-model="form.data.name"
                        :rules="[rules.noCoding, rules.exists]"
                        required
                        label="Nome"
                        outlined
                        dense
                        class="rounded-lg"
                      />
                    </v-col>

                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-text-field
                        v-model="form.data.code"
                        :rules="[rules.noCoding, rules.exists]"
                        required
                        label="Código"
                        outlined
                        dense
                        class="rounded-lg"
                      />
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                        v-model="form.data.corporateName"
                        :rules="[rules.noCoding]"
                        label="Corporação"
                        outlined
                        dense
                        class="rounded-lg"
                      />
                    </v-col>

                    <v-divider class="my-4" />

                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-text-field
                        v-model="form.data.cep"
                        v-mask="'#####-###'"
                        :rules="[rules.noCoding]"
                        label="CEP"
                        append-icon="mdi-map-marker"
                        counter="9"
                        outlined
                        dense
                        class="rounded-lg"
                        @click:append="form.getAddressByCEP()"
                        @blur="form.getAddressByCEP()"
                      />
                    </v-col>

                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-text-field
                        v-model="form.data.state"
                        :rules="[rules.noCoding]"
                        label="Estado"
                        outlined
                        dense
                        class="rounded-lg"
                      />
                    </v-col>

                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-text-field
                        v-model="form.data.city"
                        :rules="[rules.noCoding]"
                        label="Cidade"
                        outlined
                        dense
                        class="rounded-lg"
                      />
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                        v-model="form.data.address"
                        :rules="[rules.noCoding, rules.exists]"
                        required
                        label="Endereço"
                        outlined
                        dense
                        class="rounded-lg"
                      />
                    </v-col>

                    <v-divider class="my-4" />

                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-text-field
                        v-model="form.data.phoneNumber"
                        v-mask="['(##) # ####-####', '(##) ####-####']"
                        :rules="[rules.noCoding]"
                        label="Telefone"
                        outlined
                        dense
                        class="rounded-lg"
                      />
                    </v-col>

                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-text-field
                        v-model="form.data.cnpj"
                        v-mask="'##.###.###/####-##'"
                        label="CNPJ"
                        counter="18"
                        outlined
                        dense
                        class="rounded-lg"
                      />
                    </v-col>

                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-text-field
                        v-model="form.data.createdAt"
                        v-mask="'####-##-##'"
                        label="Data de criação"
                        readonly
                        outlined
                        dense
                        class="rounded-lg"
                      />
                    </v-col>
                  </v-row>
                </v-card>

                <v-divider class="invisible my-3" />

                <!-- Contatos -->
                <v-card
                  class="pa-4 rounded-xl"
                  elevation="3"
                >
                  <v-card-text
                    class="pb-4 ps-0 justify-start"
                  >
                    <v-row
                      align="center"
                    >
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <h4 class="font-weight-bold pt-2">
                          <v-icon
                            class="me-0"
                            small
                            color="primary"
                            left
                          >
                            mdi-account-box-outline
                          </v-icon>
                          Contatos
                        </h4>
                      </v-col>

                      <v-col
                        cols="12"
                        md="6"
                        class="d-flex justify-end"
                      >
                        <v-btn
                          class="rounded-pill"
                          color="primary"
                          dark
                          @click="addContact()"
                        >
                          <v-icon
                            class="me-1"
                            start
                            small
                          >
                            mdi-plus
                          </v-icon>
                          Adicionar Contato
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-divider class="mb-4" />

                  <div
                    v-for="(contact, index) in form.data.contacts"
                    :key="index"
                    class="pb-0"
                  >
                    <v-row
                      class="align-center mb-1"
                    >
                      <v-col cols="6">
                        <span class="text-subtitle-1 font-weight-medium">
                          Contato {{ index + 1 }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row
                      class="mb-2"
                      dense
                    >
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="contact.name"
                          :rules="[rules.noCoding]"
                          label="Nome"
                          class="rounded-lg"
                          outlined
                          dense
                          @input="(val) => form.data.contacts[index].name = val"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="contact.phoneNumber"
                          v-mask="['(##) # ####-####', '(##)  ####-####']"
                          :rules="[rules.noCoding]"
                          label="Telefone"
                          class="rounded-lg"
                          outlined
                          dense
                          @input="(val) => form.data.contacts[index].phoneNumber = val"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="contact.mobile"
                          v-mask="['(##) # ####-####', '(##)  ####-####']"
                          :rules="[rules.noCoding]"
                          label="Celular"
                          class="rounded-lg"
                          outlined
                          dense
                          @input="(val) => form.data.contacts[index].mobile = val"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="contact.email"
                          :rules="[rules.noCoding, rules.email, rules.exists]"
                          label="E-mail"
                          class="rounded-lg"
                          outlined
                          dense
                          @input="(val) => form.data.contacts[index].email = val"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        class="text-end"
                      >
                        <v-btn
                          class="rounded-pill me-1"
                          color="error"
                          default
                          @click="deleteContact(index)"
                        >
                          <v-icon
                            start
                            small
                          >
                            mdi-delete-outline
                          </v-icon>
                          Remover
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-card>

                <div class="py-3" />

                <!-- Serviços -->
                <v-card
                  class="pa-4 rounded-xl"
                  elevation="3"
                >
                  <v-card-text
                    class="mb-2 ps-0 justify-start"
                  >
                    <h4 class="d-flex align-center">
                      <v-icon
                        class="me-1"
                        small
                        color="primary"
                        left
                      >
                        mdi-hammer-screwdriver
                      </v-icon>
                      Serviços
                    </h4>
                  </v-card-text>

                  <v-divider class="mb-4" />

                  <!-- <service-box
                    v-for="(serviceName, index) in Object.keys(form.data.services)"
                    :key="`${serviceName}:${index}`"
                    v-model="form.data.services[serviceName]"
                    :name="serviceName"
                  /> -->

                  <service-box
                    v-model="form.data.services.clinicWeb"
                    name="Clinic Web"
                  />

                  <service-box
                    v-model="form.data.services.portal"
                    name="Portal"
                  />

                  <v-row
                    style="left: 100px;"
                    justify="start"
                  >
                    <v-col cols="6">
                      <h4>
                        Tentacle
                      </h4>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6">
                      <v-switch
                        v-model="form.data.tentacle.useCloudflareTunnels"
                        :label="`Cloudflare tunnel: ${checkboxChecker(form.data.tentacle.useCloudflareTunnels)}`"
                        color="success"
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="form.data.tentacle.version"
                        :rules="[rules.noCoding]"
                        label="Versão:"
                        outlined
                        dense
                        @input="(val)=>typingTentacle({ version: val })"
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="form.data.domain"
                        :rules="!genDomain ? [rules.noCoding,rules.exists,rules.domainFormat] : [rules.noCoding,rules.domainFormat]"
                        required
                        label="Domínio:"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="form.data.tentacle.jwtSecret"
                        :rules="[rules.noCoding]"
                        label="JWT Secret:"
                        outlined
                        dense
                        @input="(val)=>typingTentacle({ jwtSecret: val })"
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-select
                        v-model="form.data.tentacle.bucketAWS"
                        cache-items
                        label="Bucket AWS"
                        :items="bucketList"
                        item-text="Name"
                        outlined
                        dense
                        return-object
                      />
                    </v-col>
                  </v-row>

                  <div class="py-3" />

                  <v-row
                    style="left: 100px;"
                    justify="start"
                  >
                    <v-col cols="6">
                      <h4>
                        Database
                      </h4>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="form.data.connectionDB.host"
                        class="py-3"
                        label="Host:"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="form.data.connectionDB.user"
                        class="py-3"
                        label="Usuário:"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="form.data.connectionDB.password"
                        class="py-3"
                        label="Senha:"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="form.data.connectionDB.database"
                        class="py-3"
                        label="Database:"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="form.data.connectionDB.port"
                        class="py-3"
                        label="Port:"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="9">
                      <v-text-field
                        v-model="form.data.connectionDB.socketHost"
                        class="py-3"
                        label="Socket Host:"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                        v-model="form.data.connectionDB.socketPort"
                        class="py-3"
                        label="Socket Port:"
                        outlined
                        dense
                      />
                    </v-col>
                  </v-row>

                  <div class="py-3" />

                  <!-- <v-row
                    style="left: 100px;"
                    justify="start"
                  >
                    <v-col cols="6">
                      <h4>
                        Túnel
                      </h4>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6">
                      <v-switch
                        v-model="form.data.genDomain"
                        class="py-3"
                        :label="`Registrar domínio NGROK: ${checkboxChecker(form.data.genDomain)}`"
                        color="success"
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-switch
                        v-model="form.data.genToken"
                        class="py-3"
                        :label="`Gerar Token NGROK: ${checkboxChecker(form.data.genToken)}`"
                        color="success"
                      />
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="form.data.tunnelConfig.url"
                        :rules="[rules.noCoding]"
                        class="py-3"
                        label="Subdomínio:"
                        outlined
                        dense
                        @input="(val)=>typingTunnelConfig({ url: val })"
                      />
                    </v-col>
                    <v-col v-if="!genToken">
                      <v-text-field
                        v-model="form.data.tunnelConfig.credencial"
                        :rules="[rules.noCoding]"
                        class="py-3"
                        label="Credencial:"
                        outlined
                        dense
                        @input="(val)=>typingTunnelConfig({ credencial: val })"
                      />
                    </v-col>
                  </v-row> -->

                  <v-row
                    style="left: 100px;"
                    justify="start"
                  >
                    <v-col cols="6">
                      <h4>
                        Modulos e Versionamento
                      </h4>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6">
                      <v-switch
                        v-model="form.data.localModules.autoUpdate"
                        label="Habilitar Atualização Automática"
                        color="success"
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-switch
                        v-model="form.data.localModules.downgradeAllowed"
                        label="Permitir Downgrade"
                        color="success"
                      />
                    </v-col>

                    <v-row
                      v-for="(module, index) in form.data.localModules.versions"
                      :key="`moduleVersionI:${index}`"
                      class="px-3"
                    >
                      <v-col>
                        <v-text-field
                          v-model="module.name"
                          label="Sistema"
                          disabled
                          outlined
                          dense
                        />
                      </v-col>
                      <v-col v-if="!genToken">
                        <v-text-field
                          v-model="module.desiredVersion"
                          :rules="[rules.noCoding]"
                          label="Versão Desejada"
                          outlined
                          dense
                        />
                      </v-col>
                    </v-row>
                  </v-row>
                </v-card>
              </v-container>
            </v-card-text>

            <!-- Actions -->
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="error"
                text
                class="rounded-pill"
                @click="dialog = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="success"
                class="rounded-pill"
                @click="send()"
              >
                Enviar
              </v-btn>
            </v-card-actions>
          </v-form>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import { mask } from 'vue-the-mask'
  import { mapActions, mapGetters } from 'vuex'
  import axiosSync from '../../../../../axios-SYNC'
  import rules from '../../../../services/rules'
  import FormData from './formData'

  export default {
    name: 'CustomerForm',
    components: {
      serviceBox: () => import('./ServiceBox'),
    },
    directives: {
      mask,
    },
    data: () => {
      return {
        dialog: false,

        form: null,

        dateFormat: '####-##-##',
        isValid: false,
        rules: rules,

        bucketList: [],
        genDomain: false,
        genToken: false,
        domain: '',
        token: '',
      }
    },
    computed: {
      ...mapGetters('customers', ['customerList']),
    },
    mounted () {
      this.getBuckets()
    },
    methods: {
      ...mapActions('customers', ['sendCustomerForm', 'getCustomer', 'generateAuthNgrok', 'generateReservedDomain', 'getCustomerByCode']),
      async openForm ({ customerCode, customerId }, clone) {
        let customer = {}
        if (customerId) {
          customer = await this.getCustomer(customerId)
        } else if (customerCode) {
          customer = await this.getCustomerByCode(customerCode)
        }
        console.log(customerCode, customerId, customer)
        this.form = new FormData(customer, clone)

        this.dialog = true
      },
      checkboxChecker (value) {
        return value ? 'Habilitado' : 'Desabilitado'
      },

      deleteContact (value) {
        this.form.data.contacts.splice(value, 1)
      },
      addContact (val) {
        if (val) {
          this.form.data.contacts.push(JSON.parse(JSON.stringify(val)))
        } else {
          this.form.data.contacts.push(JSON.parse(JSON.stringify({
            name: '',
            phoneNumber: '',
            mobile: '',
            email: '',
          })))
        }
      },

      async checkDomainGeneration () {
        const user = JSON.parse(localStorage.getItem('user'))
        if (this.genDomain && this.form.data.tunnelConfig.url !== '') {
          const res = await this.generateReservedDomain({ user: user.name, name: this.form.data.name, subdomain: this.form.data.tunnelConfig.url })
          this.domain = 'https://' + res.domain
        }
        if (this.genToken) {
          const res = await this.generateAuthNgrok({ user: user.name, name: this.form.data.name })
          this.token = res.token
        }
      },

      async getBuckets () {
        try {
          const response = await axiosSync.get('/list/buckets')
          this.bucketList = response.data.Buckets
        } catch (err) {
          console.error('Erro buscando buckets', err)
        }
      },

      async send () {
        if (!this.$refs.form.validate()) {
          this.$alert('error', 'Existem campos obrigatórios não preenchidos.')
          return
        }

        await this.checkDomainGeneration()
        const customerData = await this.form.formatDataForServer()

        await this.sendCustomerForm(customerData)
          .then(() => {
            this.dialog = false
            this.$alert('success')
          })
          .catch((err) => {
            this.$alert('error', err.response)
          })
        this.$emit('update')
      },
    },
  }
</script>

<style scoped>
.v-text-field.rounded-lg .v-input__control {
  border-radius: 8px !important;
}

.v-btn.rounded-pill {
  border-radius: 50px !important;
  text-transform: none !important;
  font-weight: 600;
}

.v-divider.invisible {
    visibility: hidden;
}
</style>
